module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":{"accept":"利用規約に同意する"},"button":{"cancel":"キャンセル","next":"次へ"}},"en":{"label":{"accept":"I accept the agreement"},"button":{"cancel":"Cancel","next":"Next"}}}')
  delete Component.options._Ctor
}
